module.exports = __webpack_public_path__ + "img/HongXiao.413fa1f4.png";